import React, { type CSSProperties, type PropsWithChildren } from 'react';

type SvgChartCanvasProps = PropsWithChildren<{
  width: number;
  height: number;
  style?: CSSProperties;
}>;

/** DOM SVG canvas for web charts (Skia is native-only). */
export function SvgChartCanvas({ width, height, style, children }: SvgChartCanvasProps) {
  if (width <= 0 || height <= 0) {
    return null;
  }

  const canvasStyle: CSSProperties = {
    display: 'block',
    width,
    height,
    ...style,
  };

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={canvasStyle}>
      {children}
    </svg>
  );
}
